import { invert, upperFirst } from 'lodash-es';

import type { CanceledReasonEnum } from 'src/common/external/bambi-api/bambiApi';
import { OTHER_REASON_PREFIX } from 'src/features/trip/constants';

// TODO: These labels duplicate the backend's TRIP_CANCELED_REASON_CHOICES.
// They're needed to display the stored canceled_reason of an already-canceled
// trip, which the cancel-reasons endpoints can't provide (they return nothing
// for trips that can no longer be cancelled). A reason missing here falls back
// to upperFirst(value), which can diverge from the backend's label. Remove
// once trip reads serialize a canceled_reason display label.

export const CANCEL_REASON: { [key: string]: CanceledReasonEnum } = {
  NO_SHOW: 'no show',
  PASSENGER_NOT_READY: 'passenger not ready',
  PASSENGER_REFUSED: 'passenger refused',
  PASSENGER_UNABLE: 'passenger unable',
  SCHEDULING_CONFLICT: 'scheduling conflict',
  APPOINTMENT_CANCELED: 'appointment canceled',
  USER_REQUESTED: 'user requested',
  PAYER_CANCELED: 'payer canceled',
  OTHER: 'other',
};

export const CANCEL_REASONS_DISPLAY: { [key: string]: string } = {
  NO_SHOW: 'No show',
  PASSENGER_NOT_READY: 'Passenger not ready for discharge',
  PASSENGER_REFUSED: 'Passenger refused service',
  PASSENGER_UNABLE: 'Passenger unable to be transported',
  SCHEDULING_CONFLICT: 'Scheduling conflict',
  APPOINTMENT_CANCELED: 'Appointment canceled',
  USER_REQUESTED: 'User requested cancellation',
  PAYER_CANCELED: 'Payer canceled',
  OTHER: 'Other',
};

export const getCancelReasonDisplay = (reason: string) => {
  if (!reason) return '';
  const invertedCancelReasons = invert(CANCEL_REASON);
  const cancelReason = invertedCancelReasons[reason];

  if (reason.startsWith(OTHER_REASON_PREFIX)) {
    return reason.replace(OTHER_REASON_PREFIX, 'Other: ');
  }
  return CANCEL_REASONS_DISPLAY[cancelReason] || upperFirst(reason);
};
